import { render, staticRenderFns } from "./RealizarCompra.vue?vue&type=template&id=2e8ad19c&scoped=true"
import script from "./RealizarCompra.vue?vue&type=script&lang=js"
export * from "./RealizarCompra.vue?vue&type=script&lang=js"
import style0 from "./RealizarCompra.vue?vue&type=style&index=0&id=2e8ad19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ad19c",
  null
  
)

export default component.exports